export default {
  meta: {
    title: "Basetao Spreadsheet: Productos, Reseñas y Guía de Envío",
    description: "Recurso independiente sobre Basetao Spreadsheet — encuentra productos, compara vendedores, revisa fotos QC, costos de envío y si Basetao es legítimo.",
  },
  brand: "Basetao Sheet",
  nav: {
    home: "Inicio",
    categories: "Categorías",
    shoppingGuide: "Guía de compra",
    readGuide: "Leer la guía",
    safety: "Seguridad",
  },
  button: {
    buyNow: "Comprar ahora",
    basetaoSpreadsheet: "Basetao Spreadsheet",
    readGuide: "Leer la guía",
    readArticle: "Leer el artículo completo",
    exploreCategories: "Explorar categorías",
    backHome: "Volver al inicio",
    visitMain: "Visitar sitio principal",
    viewAll: "Ver todo",
  },
  cat: {
    shoes: "Zapatos",
    hoodies: "Sudaderas",
    tshirts: "Camisetas",
    jackets: "Chaquetas",
    pants: "Pantalones / Shorts",
    headwear: "Gorras y sombreros",
    sets: "Conjuntos",
    underwear: "Ropa interior / Calzoncillos",
    jersey: "Camisetas deportivas",
    accessories: "Accesorios",
    bags: "Bolsos",
    belts: "Cinturones",
    perfumes: "Perfumes",
    other: "Otros artículos",
  },
  notFound: {
    title: "Página no encontrada",
    desc: "La página que buscas no existe o ha sido movida.",
  },
  footer: {
    tagline: "Recurso informativo independiente sobre Basetao Spreadsheet.",
    quickLinks: "Enlaces rápidos",
    categories: "Categorías",
    disclaimer: "Basetao Sheet es un recurso informativo independiente y no está afiliado oficialmente a Basetao. La información puede cambiar y debe verificarse antes de comprar o pagar.",
    allRights: "Todos los derechos reservados.",
  },
  articleMeta: {
    shortAnswerLabel: "Respuesta breve",
    tocTitle: "Índice",
    checklistTitle: "Puntos clave a verificar",
    faqTitle: "Preguntas frecuentes",
    conclusionTitle: "En resumen",
    authorLabel: "Autor",
    author: "Equipo editorial de Basetao Sheet",
    publishedLabel: "Publicado",
    published: "2026",
    updatedLabel: "Actualizado",
    updated: "Agosto de 2026",
    disclaimer:
      "Basetao Sheet es un recurso informativo independiente y no está afiliado oficialmente a Basetao. La información puede cambiar y debe verificarse antes de comprar o pagar.",
  },
};